var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.5,
    height: 50,
    viewBox: "0 0 47.5 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.091,
    y1: 0.197,
    x2: 0.064,
    y2: 0.892,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15de8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0daa7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#078471"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "network",
    transform: "translate(-1090 -2208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M47.5,14a5,5,0,1,0,5,5A5,5,0,0,0,47.5,14Zm0,20a5,5,0,1,0,5,5A5,5,0,0,0,47.5,34ZM10,14a5,5,0,1,0,5,5A5,5,0,0,0,10,14Zm0,20a5,5,0,1,0,5,5A5,5,0,0,0,10,34ZM28.75,44a5,5,0,1,0,5,5A5,5,0,0,0,28.75,44Zm0-40a5,5,0,1,0,5,5A5,5,0,0,0,28.75,4Z",
    transform: "translate(1085 2204)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M35.339,31.24A10.259,10.259,0,0,0,26.17,26,10.259,10.259,0,0,0,17,31.24v2.62H35.339Z",
    transform: "translate(1087.58 2209.268)",
    fill: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M25.24,16a5.24,5.24,0,1,0,5.24,5.24A5.24,5.24,0,0,0,25.24,16Z",
    transform: "translate(1088.51 2208.142)",
    fill: "#c77600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.12a7dc02eab76da14d41690bf0886d85.svg";
export { ForwardRef as ReactComponent };